export default __webpack_public_path__ + "static/media/36I-102747_-17344_0.3bcc6b1a.jpg";